import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import Select from "react-select";
import moment from "moment";
import Swal from "sweetalert2";
import NoteModal from "../../component/modal/note-modal";
import TaskModal from "../../component/modal/task-modal";
import { AiOutlinePrinter } from "react-icons/ai";
import { FaTasks, FaInfoCircle, FaCalendarAlt, FaBuilding, FaMoneyBillWave, FaUniversity } from "react-icons/fa";
import { API_URL } from "../../const";
import { Oval } from "react-loader-spinner";
import { toast } from "react-toastify";
import { AiOutlineDelete, AiOutlineFileExcel } from "react-icons/ai";
import { GrNotes } from "react-icons/gr";
import ReactToPrint from "react-to-print";
import { SiMicrosoftexcel } from "react-icons/si";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Statement01AModule from "./Statement01AModule";
import AnnexureBModule from "./AnnexureBModule";
import DeclarationModule from "./DeclarationModule";
import MonthlyTotalsModule from "./MonthlyTotalsModule";
import MaxRefundModule from "./MaxRefundModule";
import GSTR2BImportModule from "./GSTR2BImportModule";
import Gstr2bHsnModule from "./Gstr2bHsnModule";

const taskCardStyles = `
.task-card {
  border: 1px solid #e5e5e5;
  padding: 16px;
  border-radius: 10px;
  background: #fff;
  margin-bottom: 12px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.02);
  transition: all 0.2s ease;
}
.task-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.08);
  border-color: #d1d1d1;
}
.task-main {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}
.firm-name {
  font-weight: 700;
  font-size: 16px;
  color: #1a1a1a;
}
.gstin-small {
  font-size: 12px;
  color: #6c757d;
  font-weight: normal;
}
.status-badge {
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
}
.status-pending { background: #fff5f5; color: #e53e3e; border: 1px solid #feb2b2; }
.status-completed { background: #f0fff4; color: #38a169; border: 1px solid #9ae6b4; }

.task-amount {
  display: flex;
  justify-content: space-between;
  font-weight: 600;
  font-size: 14px;
  margin-top: 4px;
  color: #4a5568;
}

.task-sub {
  margin-top: 12px;
  padding: 8px 12px;
  background: #f8fafc;
  border-radius: 8px;
  font-size: 12px;
  color: #4a5568;
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
  border: 1px solid #edf2f7;
}
.sub-item { display: flex; align-items: center; gap: 6px; }
.sub-item svg { color: #d97706; }

.task-actions {
  display: flex;
  gap: 8px;
  margin-left: 15px;
}
`;


// ── GST Extension Bridge (postMessage — no extension ID needed) ─────────────
// The extension injects bridge.js into this page which relays postMessage
// calls to the extension background. Works on ANY PC automatically.

/**
 * Send a message to the GST Extension background via the postMessage bridge.
 * Returns a Promise that resolves with the background's response.
 * Times out after 60 seconds (screenshot capture can take a while).
 */
const sendExtMessage = (msg, timeoutMs = 60000) =>
  new Promise((resolve) => {
    const requestId = Math.random().toString(36).slice(2) + Date.now();

    const handler = (event) => {
      if (!event.data || event.data.__GST_EXT_FROM_BG__ !== true) return;
      if (event.data.requestId !== requestId) return;
      window.removeEventListener('message', handler);
      clearTimeout(timer);
      resolve(event.data.response);
    };

    const timer = setTimeout(() => {
      window.removeEventListener('message', handler);
      resolve({ error: 'TIMEOUT — extension did not respond in time' });
    }, timeoutMs);

    window.addEventListener('message', handler);
    window.postMessage({ __GST_EXT_TO_BG__: true, requestId, payload: msg }, '*');
  });

/**
 * Quick check — first checks the synchronous flag set by bridge.js,
 * then does a PING to confirm the background is alive.
 * Uses 8s timeout to handle MV3 service worker wake-up delay.
 */
const isExtensionReady = async () => {
  // Fast path: bridge.js injects this meta tag when it's loaded
  if (!document.querySelector('meta[name="gst-bridge-active"]')) {
    return false; // bridge.js not injected → extension not loaded or page not refreshed
  }
  // Slow path: ping the background (may need to wake the service worker)
  const res = await sendExtMessage({ type: 'GST_PING' }, 8000);
  return !res?.error;
};

const NonRoutine = () => {
  let componentRef = useRef();
  const [loading, setLoading] = useState(true);

  const getRefundExtData = (row) => {
    if (!row || (row.lookup?.key_name !== "GST Refund" && row.lookup?.kay_value !== "GST Refund")) return null;

    if (!row.arn && !row.date_of_filing && !row.jurisdiction && !row.refund_applied && !row.refund_deposit) {
      return null;
    }

    return {
      arn: row.arn,
      dateOfFiling: row.date_of_filing,
      days: row.days,
      jurisdiction: row.jurisdiction,
      refundApplied: row.refund_applied,
      refundDeposit: row.refund_deposit
    };
  };

  const getGstExtraData = (row) => {
    if (!row || (row.lookup?.key_name !== "GST Refund" && row.lookup?.kay_value !== "GST Refund")) return null;
    if (!row.from_date && !row.to_date) return null;
    return {
      from: row.from_date,
      to: row.to_date
    };
  };

  const [clientList, setClientList] = useState([]);
  const [isProcessing, setIsProcessing] = React.useState(false);
  const [currentProcessIndex, setCurrentProcessIndex] = React.useState(0);
  const [countdown, setCountdown] = React.useState(0);
  const [nonroutingclientList, setNonRoutingClientList] = useState([]);
  const [allTask, setAllTask] = useState([]);
  const [shownotes, setShowNotes] = useState(false);
  const [showTaskModal, setShowTaskModal] = useState(false);
  const [showGstRefundModal, setShowGstRefundModal] = useState(false);
  const [showGstRefundTableModal, setShowGstRefundTableModal] = useState(false);
  const [currentRow, setCurrentRow] = useState({});
  const [options, setOptions] = useState();
  const [formData, setFormData] = useState({
    client_id: "",
    lookup_id: "",
  });

  const [filterData, setFilterData] = useState([
    { key: "name", value: "" },
    { key: "task", value: "" },
    { key: "number", value: "" },
    { key: "date", value: "" },
    { key: "status", value: "" },
  ]);

  const getClient = () => {
    axios.post(API_URL.CLIENT_LIST, {}).then((res) => {
      if (res.data.status === 1) {
        res.data.data.map((item) => {
          item.label = item.firm_name;
          item.value = item.id;
        });
        setClientList(res.data.data);
      }
    });
  };

  const getLookup = () => {
    axios
      .post(API_URL.LOOKUP_LIST, { key_type: ["Non Routing"] })
      .then((res) => {
        if (res.data.status === 1) {
          const rout = res.data.data.map((item) => {
            return {
              label: item.key_name,
              value: item.id,
            };
          });
          setOptions(rout);
        }
      });
  };

  const getNonRoutingClient = () => {
    axios.post(API_URL.NOT_ROUTING_LIST, {}).then((res) => {
      if (res.data.status === 1) {
        let data = res.data.data.map((element) => {
          return {
            ...element,
            name: element.client.firm_name,
            task: element.lookup.key_name,
            number: element.client.person_one_no,
            date: moment(element.created_at).format("DD/MM/YYYY hh:mm A"),
            status: element.status.toString(),
          };
        });
        setAllTask(data);
        sortStatusByData(res.data.data);
      }
      setLoading(false);
    });
  };

  const addUpdateSteps = (client_id, lookup_id) => {
    axios
      .post(API_URL.TASK_CLIENT, {
        client_id: client_id,
        lookup_id: lookup_id,
      })
      .then((res) => {
        if (res.data.status != 1) {
          toast.info("Task not available...");
        }
      });
  };

  const saveData = () => {
    let url = API_URL.NOT_ROUTING_SAVE;
    let body = { ...formData };
    axios.post(url, body).then((response) => {
      addUpdateSteps(body.client_id, body.lookup_id)
      if (response.data.status === 1) {
        getNonRoutingClient();
        setFormData({
          client_id: "",
          lookup_id: "",
        });
      } else {
        if (response.data && response.data.data) {
          toast.error("something Went Wromg.....", {
            autoClose: 3000,
            position: "top-center",
          });
        }
      }
    });
  };

  const deleteNonRoutingEmployee = (res) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Want to delete?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios.post(API_URL.NOT_ROUTING_DELETE, { id: res.id }).then((res) => {
          if (res.data.status === 1) {
            getNonRoutingClient();
            toast.success("Successfully Non Routing Task Deleted", {
              autoClose: 3000,
              position: "top-center",
            });
          } else {
            toast.error(res.data.data, {
              autoClose: 3000,
              position: "top-center",
            });
          }
        });
      }
    });
  };

  useEffect(() => {
    getLookup();
    getClient();
    getNonRoutingClient();
  }, []);

  const handleShowNotes = (note) => {
    setCurrentRow({
      id: note.client.id,
      file_no: note.client.file_no,
      name: note.client.name,
    });
    setShowNotes(true);
  };

  const exportToExcel = (res, extraData = {}) => {
    const fullAddress = [
      res.client.address_line_one,
      res.client.address_line_two,
      res.client.city,
      res.client.state,
      res.client.pincode
    ].filter(Boolean).join(", ");

    const data = [
      ["Applicant Name", "GSTIN", "Address", "Place", "Designation", "From", "To", "Refund Amount (Formula)", "Refund Amount (After Upload)"],
      [
        res.client.firm_name || "",
        res.client.gstin_no || "",
        fullAddress || "",
        res.client.city || "",
        extraData.designation || "Partner / Proprietor",
        extraData.from ? moment(extraData.from).format("MMYYYY") : "",
        extraData.to ? moment(extraData.to).format("MMYYYY") : "",
        extraData.refundFormula || "",
        extraData.refundAfterUpload || ""
      ]
    ];

    const csvContent = "data:text/csv;charset=utf-8,\uFEFF"
      + data.map(e => e.map(val => `"${(val || "").toString().replace(/"/g, '""')}"`).join(",")).join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", `${res.client.firm_name}_GST_Refund.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const isValidForm = () => {
    return formData.client_id && formData.lookup_id;
  };

  useEffect(() => {
    let copyData = [...allTask];
    let selSearch = filterData.filter((d) => d.value);
    if (selSearch.length > 0) {
      let filterArray = [];
      copyData.map((res) => {
        let flagArray = [];
        selSearch.map((filter) => {
          if (res[filter.key]) {
            let flag =
              res[filter.key]
                .toLowerCase()
                .indexOf(filter.value.toLowerCase()) > -1;
            if (flag) {
              flagArray.push(flag);
            }
          }
        });
        if (flagArray.length === selSearch.length) {
          filterArray.push(res);
        }
      });
      sortStatusByData(filterArray);
    } else {
      sortStatusByData(copyData);
    }
  }, [filterData]);

  const sortStatusByData = (data) => {
    let sortData = data.sort((a, b) => {
      const getPriority = (res) => {
        const isRefundType = res.lookup?.key_name === "GST Refund" || res.lookup?.kay_value === "GST Refund";
        const dep = res.refund_deposit ? parseFloat(res.refund_deposit) : 0;
        const app = res.refund_applied ? parseFloat(res.refund_applied) : 0;

        if (isRefundType) {
          if (dep > 0) return 2; // Refund Sanctioned
          if (app > 0) return 1; // Refund Filed and Not Sanctioned
        }

        if (res.status == 1) return 3; // Completed
        return 0; // In Progress
      };

      return getPriority(a) - getPriority(b);
    });
    setNonRoutingClientList(sortData);
  };

  const checkAllRefundStatus = async () => {
    // Get LIVE list from current state — never hardcoded
    const filedTasks = nonroutingclientList.filter((res) => {
      const isRefundType =
        res.lookup?.key_name === "GST Refund" ||
        res.lookup?.kay_value === "GST Refund";
      const dep = res.refund_deposit ? parseFloat(res.refund_deposit) : 0;
      const app = res.refund_applied ? parseFloat(res.refund_applied) : 0;
      return isRefundType && app > 0 && dep <= 0 && res.arn;
    });

    if (filedTasks.length === 0) {
      toast.info("No ARNs found in Refund Filed and Not Sanctioned category.");
      return;
    }

    // Check Chrome Extension is installed and bridge.js is active
    const ready = await isExtensionReady();
    if (!ready) {
      toast.error(
        "GST Bridge Chrome Extension not found! Load it from gst-ext folder in chrome://extensions, then reload this page."
      );
      return;
    }

    toast.info(
      `Starting Chrome Extension screenshot capture for ${filedTasks.length} ARNs...`
    );
    setIsProcessing(true);

    try {
      for (let i = 0; i < filedTasks.length; i++) {
        setCurrentProcessIndex(i);
        const task = filedTasks[i];

        toast.info(
          `Processing ${i + 1}/${filedTasks.length}: ${task.arn} — ${task.client?.firm_name || ""
          } (opening GST portal...)`
        );

        // Countdown UI while extension works
        let secondsLeft = 15;
        setCountdown(secondsLeft);
        const countdownTimer = setInterval(() => {
          secondsLeft -= 1;
          setCountdown(Math.max(secondsLeft, 0));
        }, 1000);

        try {
          // Ask the Chrome Extension to open GST portal, fill form, and screenshot
          const result = await sendExtMessage({
            type: 'GST_CAPTURE_SCREENSHOT',
            arn: task.arn,
          });

          clearInterval(countdownTimer);
          setCountdown(0);

          if (result?.success) {
            toast.success(`✓ Screenshot captured for ${task.arn}`);
          } else {
            toast.error(`✗ Failed: ${task.arn} — ${result?.error || 'Unknown error'}`);
          }
        } catch (e) {
          clearInterval(countdownTimer);
          setCountdown(0);
          console.error(`Could not capture screenshot for ${task.arn}`, e);
          toast.error(`Failed to capture ${task.arn}`);
        }

        // Small delay between each ARN to avoid overwhelming browser
        if (i < filedTasks.length - 1) await new Promise(r => setTimeout(r, 2000));
      }

      setIsProcessing(false);
      toast.success(
        `All ${filedTasks.length} ARNs processed! Generating your final report now...`
      );

      // Automatically generate the report with all captured screenshots
      await downloadFreshReport();
    } catch (err) {
      console.error(err);
      toast.error("Process interrupted.");
      setIsProcessing(false);
    }
  };

  const downloadFreshReport = async () => {
    // Get LIVE current ARN list — never hardcoded
    const filedTasks = nonroutingclientList.filter((res) => {
      const isRefundType =
        res.lookup?.key_name === "GST Refund" ||
        res.lookup?.kay_value === "GST Refund";
      const dep = res.refund_deposit ? parseFloat(res.refund_deposit) : 0;
      const app = res.refund_applied ? parseFloat(res.refund_applied) : 0;
      return isRefundType && app > 0 && dep <= 0 && res.arn;
    });

    if (filedTasks.length === 0) {
      toast.info("No ARNs found to include in report.");
      return;
    }

    toast.info(`Building printable report for ${filedTasks.length} ARNs...`);

    // Fetch screenshot dataUrls from Chrome Extension storage
    const screenshotMap = {};
    for (const task of filedTasks) {
      const res = await sendExtMessage({
        type: 'GST_GET_SCREENSHOT',
        arn: task.arn,
      });
      if (res?.success && res.dataUrl) {
        screenshotMap[task.arn] = res.dataUrl;
      }
    }

    const today = new Date();
    const dateStr = today.toLocaleDateString("en-IN", {
      day: "2-digit", month: "long", year: "numeric",
    });
    const timeStr = today.toLocaleTimeString("en-IN");

    // Build one full-page HTML block per ARN (each is a print page)
    const pages = filedTasks.map((t, i) => {
      const img = screenshotMap[t.arn]
        ? `<img src="${screenshotMap[t.arn]}" style="width:100%;max-height:85vh;object-fit:contain;display:block;margin:0 auto;"/>`
        : `<div style="padding:60px;text-align:center;color:#c00;font-size:18px">No screenshot available for ARN: ${t.arn}<br/><small>Run "Check Refund Status" first.</small></div>`;

      return `
        <div class="page">
          <div class="page-header">
            <span>Case ${i + 1} of ${filedTasks.length} &nbsp;|&nbsp; ARN: <b>${t.arn}</b></span>
            <span>${t.client?.firm_name || ""} &nbsp;|&nbsp; ₹${t.refund_applied || "0"} &nbsp;|&nbsp; ${t.jurisdiction || ""}</span>
          </div>
          ${img}
          <div class="page-footer">GST Refund Status Report &nbsp;|&nbsp; Page ${i + 3} of ${filedTasks.length + 2} &nbsp;|&nbsp; ${dateStr} &nbsp;|&nbsp; Confidential</div>
        </div>`;
    }).join("");

    // Index table rows
    const indexRows = filedTasks.map((t, i) => `
      <tr style="background:${i % 2 === 0 ? '#eaf0fb' : '#fff'}">
        <td>${i + 1}</td>
        <td><b>${t.arn}</b></td>
        <td>${t.client?.firm_name || "—"}</td>
        <td>${t.jurisdiction || "—"}</td>
        <td>₹${t.refund_applied || "0"}</td>
        <td>${t.date_of_filing || "—"}</td>
        <td>${i + 3}</td>
      </tr>`).join("");

    const html = `<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8"/>
  <title>GST Refund Status Report</title>
  <style>
    * { box-sizing: border-box; margin: 0; padding: 0; }
    body { font-family: Arial, sans-serif; font-size: 12px; background: #fff; }
    .page { width: 100%; min-height: 100vh; page-break-after: always; display: flex; flex-direction: column; padding: 0; position: relative; }
    .page:last-child { page-break-after: avoid; }
    .page-header { background: #1a3c6e; color: #fff; padding: 10px 20px; display: flex; justify-content: space-between; font-size: 11px; }
    .page-footer { position: absolute; bottom: 0; left: 0; right: 0; text-align: center; font-size: 8px; color: #888; padding: 4px; border-top: 1px solid #eee; }
    .cover { display: flex; flex-direction: column; align-items: center; justify-content: center; min-height: 100vh; background: linear-gradient(135deg, #1a3c6e 0%, #2d5fa6 100%); color: white; text-align: center; }
    .cover h1 { font-size: 32px; margin-bottom: 12px; }
    .cover h2 { font-size: 16px; opacity: 0.85; margin-bottom: 8px; }
    .cover .meta { margin-top: 40px; font-size: 14px; opacity: 0.9; line-height: 2; }
    .index-page { padding: 40px; min-height: 100vh; }
    table { width: 100%; border-collapse: collapse; margin-top: 16px; }
    th { background: #1a3c6e; color: #fff; padding: 8px 6px; text-align: left; }
    td { border: 1px solid #ddd; padding: 6px; }
    @media print {
      body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
      .page { page-break-after: always; min-height: 100vh; }
    }
  </style>
</head>
<body>

  <!-- Cover Page -->
  <div class="page cover">
    <h1>GST REFUND STATUS REPORT</h1>
    <h2>Refund Filed and Not Sanctioned</h2>
    <p style="opacity:0.7;margin-top:8px">Source: CA ERP — nonRoutine Module</p>
    <div class="meta">
      <div>Total ARNs: <b>${filedTasks.length}</b></div>
      <div>Report Date: ${dateStr}</div>
      <div>Generated At: ${timeStr}</div>
    </div>
    <p style="position:absolute;bottom:20px;font-size:10px;opacity:0.6">Fresh report — generated on-demand. Never cached.</p>
  </div>

  <!-- Index Page -->
  <div class="page index-page">
    <h2 style="font-size:20px;text-decoration:underline;margin-bottom:20px">INDEX</h2>
    <table>
      <thead><tr><th>#</th><th>ARN Number</th><th>Client Name</th><th>Jurisdiction</th><th>Refund Applied</th><th>Date of Filing</th><th>Page</th></tr></thead>
      <tbody>${indexRows}</tbody>
    </table>
    <div style="position:absolute;bottom:8px;left:0;right:0;text-align:center;font-size:8px;color:#888">GST Refund Status Report &nbsp;|&nbsp; Page 2 of ${filedTasks.length + 2} &nbsp;|&nbsp; ${dateStr} &nbsp;|&nbsp; Confidential</div>
  </div>

  <!-- ARN Pages -->
  ${pages}

  <script>setTimeout(() => window.print(), 800);</script>
</body>
</html>`;

    const win = window.open("", "_blank");
    if (!win) {
      toast.error("Popup blocked! Please allow popups and try again.");
      return;
    }
    win.document.write(html);
    win.document.close();
    toast.success(`Report opened — ${filedTasks.length} ARNs with screenshots. Use Print → Save as PDF.`);
  };

  const yearWiseDeposits = React.useMemo(() => {
    const totals = {};
    nonroutingclientList.forEach((res) => {
      const extData = getRefundExtData(res);
      if (extData && extData.refundDeposit && extData.dateOfFiling) {
        let amount = parseFloat(extData.refundDeposit);
        if (amount > 0) {
          let yearLabel = "Other";
          const mDate = moment(extData.dateOfFiling);
          if (mDate.isValid()) {
            const year = mDate.year();
            const month = mDate.month(); // 0 is January
            yearLabel = month < 3 ? `${year - 1}-${year}` : `${year}-${year + 1}`;
          }
          totals[yearLabel] = (totals[yearLabel] || 0) + amount;
        }
      }
    });
    return totals;
  }, [nonroutingclientList]);

  return (
    <>
      <div className="w-100">
        <div className="card shadow-sm ctm-border-radius">
          <div className="card-body align-center">
            <h4 className="title card-title float-left mb-0">
              Non Routing Index
            </h4>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-md-4">
                <Select
                  className="basic-single mr-2 w-100"
                  name="color"
                  options={clientList}
                  placeholder="Select Client.."
                  value={
                    formData.client_id
                      ? clientList.find((r) => r.value == formData.client_id)
                      : null
                  }
                  onChange={(e) =>
                    setFormData({ ...formData, client_id: e.value })
                  }
                />
              </div>
              <div className="col-md-4">
                <Select
                  className="basic-single w-100"
                  name="color"
                  options={options}
                  placeholder="Select Non Routing Type.."
                  value={
                    formData.lookup_id
                      ? options.find((r) => r.value == formData.lookup_id)
                      : null
                  }
                  onChange={(e) =>
                    setFormData({ ...formData, lookup_id: e.value })
                  }
                />
              </div>
              <div className="col-md-4">
                <button
                  className="btn btn-theme ctm-border-radius text-white"
                  onClick={saveData}
                  disabled={!isValidForm()}
                >
                  Save
                </button>
                <button
                  className="btn btn-warning ctm-border-radius text-white ml-2"
                  onClick={checkAllRefundStatus}
                  disabled={isProcessing}
                >
                  {isProcessing
                    ? `Checking ${currentProcessIndex + 1}... (${countdown}s)`
                    : "Check Refund Status"}
                </button>

                <button
                  className="btn btn-primary ctm-border-radius text-white ml-2"
                  onClick={downloadFreshReport}
                  disabled={isProcessing}
                >
                  Download Fresh Report
                </button>
                {componentRef && (
                  <ReactToPrint
                    content={() => componentRef}
                    trigger={() => {
                      return (
                        <button
                          style={{ borderBottom: "0px" }}
                          className="btn btn-danger text-white ctm-border-radius float-right mr-3"
                        >
                          <AiOutlinePrinter size={25} />
                        </button>
                      );
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="w-100">
        <div className="card shadow-sm ctm-border-radius">
          <div className="card-body">
            {loading ? (
              <Oval
                height={60}
                width={60}
                color="#7539ff"
                wrapperStyle={{ justifyContent: "center" }}
                wrapperClass=""
                visible={true}
                ariaLabel="oval-loading"
                secondaryColor="#7539ff"
                strokeWidth={2}
                strokeWidthSecondary={2}
              />
            ) : (
              <div ref={(el) => (componentRef = el)}>
                <style>{taskCardStyles}</style>

                {/* Search / Filter Section */}
                <div className="card mb-4 p-3 shadow-sm border-0" style={{ borderRadius: '12px', background: '#fcfcfc' }}>
                  <div className="row">
                    {filterData.map((row, kd) => (
                      <div key={kd} className="col-md-2 mb-2">
                        <label className="small font-weight-bold text-muted mb-1">{row.key}</label>
                        <input
                          placeholder={`Search...`}
                          type="text"
                          className="form-control form-control-sm"
                          style={{ borderRadius: '6px' }}
                          value={row.value}
                          onChange={(e) => {
                            let copyData = [...filterData];
                            let index = copyData.findIndex((d) => d.key === row.key);
                            copyData[index].value = e.target.value;
                            setFilterData(copyData);
                          }}
                        />
                      </div>
                    ))}
                  </div>
                </div>

                {/* Year Wise GST Refund Deposit Summary */}
                {Object.keys(yearWiseDeposits).length > 0 && (
                  <div className="card mb-3 p-3 shadow-sm" style={{ borderRadius: '12px', background: '#ecfdf5', border: '1px solid #10b981' }}>
                    <div className="d-flex align-items-center mb-2">
                      <FaMoneyBillWave size={18} style={{ color: '#059669' }} className="mr-2" />
                      <h6 className="font-weight-bold mb-0 m-0" style={{ color: '#059669' }}>Total Year Wise GST Refund Deposited</h6>
                    </div>
                    <div className="d-flex flex-wrap mt-2">
                      {Object.keys(yearWiseDeposits).sort((a, b) => b.localeCompare(a)).map((year) => (
                        <span key={year} className="badge px-3 py-2 mr-2 mb-2" style={{ backgroundColor: '#10b981', color: 'white', fontSize: '14px', borderRadius: '8px' }}>
                          FY {year}: ₹{yearWiseDeposits[year].toLocaleString('en-IN')}
                        </span>
                      ))}
                    </div>
                  </div>
                )}

                {/* Card List */}
                <div className="task-list-container">
                  {nonroutingclientList.map((res, key) => {
                    const extData = getRefundExtData(res);
                    return (
                      <div key={key} className="task-card">
                        <div className="task-main">
                          <div className="firm-name">
                            {res.client.firm_name}
                            <span className="gstin-small ml-2">({res.client.gstin_no || "No GSTIN"})</span>
                          </div>
                          <div className="d-flex align-items-center">
                            <span className={`status-badge ${res.status == 1 ? "status-completed" : "status-pending"}`}>
                              {res.status == 1 ? "Completed" : "Pending"}
                            </span>

                            <div className="task-actions ml-3">
                              {res.status == 0 && (
                                <button
                                  type="button"
                                  className="btn btn-sm btn-outline-danger border-0"
                                  onClick={() => deleteNonRoutingEmployee(res)}
                                  title="Delete"
                                >
                                  <AiOutlineDelete size={18} />
                                </button>
                              )}
                              <button
                                type="button"
                                className="btn btn-sm btn-outline-info border-0"
                                onClick={() => handleShowNotes(res)}
                                title="Notes"
                              >
                                <GrNotes size={18} />
                              </button>
                              {res.status == 0 && (
                                <button
                                  type="button"
                                  className="btn btn-sm btn-outline-warning border-0"
                                  onClick={() => {
                                    setCurrentRow(res);
                                    setShowTaskModal(true);
                                  }}
                                  title="Tasks"
                                >
                                  <FaTasks size={18} />
                                </button>
                              )}
                              {(res.lookup.key_name === "GST Refund" || res.lookup.kay_value === "GST Refund") && (
                                <>
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-outline-success border-0"
                                    onClick={() => {
                                      setCurrentRow(res);
                                      setShowGstRefundModal(true);
                                    }}
                                    title="Excel Export"
                                  >
                                    <SiMicrosoftexcel size={18} />
                                  </button>
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-outline-primary border-0"
                                    onClick={() => {
                                      setCurrentRow(res);
                                      setShowGstRefundTableModal(true);
                                    }}
                                    title="Status Details"
                                  >
                                    <FaInfoCircle size={18} />
                                  </button>
                                </>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="task-amount">
                          <div>
                            <span className="text-muted small">Type:</span> <span className="badge badge-light px-2 ml-1">{res.lookup.key_name}</span>
                            {(() => {
                              if (res.lookup.key_name !== "GST Refund" && res.lookup.kay_value !== "GST Refund") return null;
                              const dep = extData?.refundDeposit ? parseFloat(extData.refundDeposit) : 0;
                              const app = extData?.refundApplied ? parseFloat(extData.refundApplied) : 0;
                              if (dep > 0) return <span className="badge px-2 ml-2" style={{ backgroundColor: '#dc3545', color: 'white' }}>Refund Sanctioned</span>;
                              if (app > 0) return <span className="badge px-2 ml-2" style={{ backgroundColor: '#ffc107', color: 'black' }}>Refund Filed and Not Sanctioned - {extData.arn}</span>;
                              if (res.status == 0) return <span className="badge px-2 ml-2" style={{ backgroundColor: '#17a2b8', color: 'white' }}>In Progress</span>;
                              return null;
                            })()}
                            {extData?.refundDeposit && (
                              <span className="ml-3">
                                <span className="text-muted small">Refund Amount:</span> <b>₹{extData.refundDeposit}</b>
                              </span>
                            )}
                          </div>
                          <div>
                            <span className="text-muted small">Owner:</span> <span className="font-weight-bold ml-1">{res.assign_by_user?.first_name || "Unassigned"}</span>
                          </div>
                        </div>

                        {(() => {
                          const gstExt = getGstExtraData(res);
                          if (!extData && (!gstExt || (!gstExt.from && !gstExt.to))) return null;

                          return (
                            <div className="task-sub">
                              {extData && (
                                <>
                                  <div className="sub-item">
                                    <FaCalendarAlt size={12} />
                                    <span><b>Date Gone:</b> {extData.dateOfFiling || "N/A"} ({extData.days || 0} Days)</span>
                                  </div>
                                  <div className="sub-item">
                                    <FaBuilding size={12} />
                                    <span><b>Jurisdiction:</b> {extData.jurisdiction || "N/A"}</span>
                                  </div>
                                  <div className="sub-item">
                                    <FaMoneyBillWave size={12} />
                                    <span><b>Applied:</b> ₹{extData.refundApplied || 0}</span>
                                  </div>
                                  <div className="sub-item">
                                    <FaUniversity size={12} />
                                    <span><b>GST Refunded (Deposited):</b> ₹{extData.refundDeposit || 0}</span>
                                  </div>
                                </>
                              )}
                              {gstExt && (gstExt.from || gstExt.to) && (
                                <div className="sub-item">
                                  <FaCalendarAlt size={12} />
                                  <span><b>GST Refund Period:</b> {gstExt.from ? moment(gstExt.from).format("MM/YYYY") : "N/A"} to {gstExt.to ? moment(gstExt.to).format("MM/YYYY") : "N/A"}</span>
                                </div>
                              )}
                            </div>
                          );
                        })()}

                        <div className="mt-2 text-right d-flex justify-content-between border-top pt-2">
                          <small className="text-muted">Client No: {res.client.person_one_no}</small>
                          <small className="text-muted">Created: {moment(res.created_at).format("DD/MM/YYYY hh:mm A")}</small>
                        </div>
                      </div>
                    );
                  })}
                </div>

                <NoteModal
                  firmType={"Non Routing"}
                  openNotes={shownotes}
                  note={currentRow}
                  onCloseNotes={() => setShowNotes(false)}
                ></NoteModal>
                <TaskModal
                  open={showTaskModal}
                  row={currentRow}
                  onCloseModal={(event) => {
                    setShowTaskModal(false);
                    event && getNonRoutingClient();
                  }}
                />
                <GSTRefundModal
                  open={showGstRefundModal}
                  row={currentRow}
                  onClose={() => setShowGstRefundModal(false)}
                />
                <GSTRefundTableModal
                  open={showGstRefundTableModal}
                  row={currentRow}
                  onClose={(event) => {
                    setShowGstRefundTableModal(false);
                    event && getNonRoutingClient();
                  }}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default NonRoutine;

const GSTRefundModal = ({ open, row, onClose }) => {
  // ── localStorage key scoped to this client ────────────────────────────────
  const lsExtraKey = `gst_extradata_${row?.client?.id || row?.id || 'default'}`;

  const [extraData, setExtraData] = useState({
    designation: "Partner / Proprietor",
    from: null,
    to: null,
    refundFormula: "",
    refundAfterUpload: ""
  });
  const [mainTab, setMainTab] = useState('stmt');
  const [stmtData, setStmtData] = useState({ inwardData: [], outwardData: [] });
  const [annexRows, setAnnexRows] = useState([]);

  // ── Load extraData from localStorage when the row (client) changes ─────────
  useEffect(() => {
    if (!row?.client?.id && !row?.id) return;
    try {
      const saved = localStorage.getItem(lsExtraKey);
      let parsed = {};
      if (saved) {
        parsed = JSON.parse(saved);
      }
      setExtraData({
        ...parsed,
        designation: parsed.designation || "Partner / Proprietor",
        refundFormula: parsed.refundFormula || "",
        refundAfterUpload: parsed.refundAfterUpload || "",
        from: row.from_date ? new Date(row.from_date) : null,
        to: row.to_date ? new Date(row.to_date) : null,
      });
    } catch (err) {
      console.warn('GSTRefundModal: failed to load extraData from localStorage', err);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lsExtraKey, row]);

  const updateDatesToApi = (fromDate, toDate) => {
    let payload = {
      id: row.id,
      client_id: row?.client?.id || row.client_id,
      lookup_id: row?.lookup?.id || row.lookup_id,
      status: row.status !== undefined ? row.status : 1,
      from_date: fromDate ? moment(fromDate).format("YYYY-MM-DD") : null,
      to_date: toDate ? moment(toDate).format("YYYY-MM-DD") : null
    };

    axios.post(API_URL.NOT_ROUTING_UPDATE, payload).then((res) => {
      if (res.data.status === 1) {
        toast.success("Dates updated successfully", { autoClose: 2000 });
      } else {
        toast.error("Failed to update dates", { autoClose: 2000 });
      }
    });
  };

  // ── Auto-save extraData to localStorage on every change ───────────────────
  useEffect(() => {
    if (!row?.client?.id && !row?.id) return;
    try {
      localStorage.setItem(lsExtraKey, JSON.stringify({
        ...extraData,
        // Serialize Dates to ISO strings for storage
        from: extraData.from ? extraData.from.toISOString() : null,
        to: extraData.to ? extraData.to.toISOString() : null,
      }));
    } catch (err) {
      console.warn('GSTRefundModal: failed to save extraData to localStorage', err);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [extraData]);

  const statementRows = React.useMemo(() => {
    const { inwardData, outwardData } = stmtData;
    const maxRows = Math.max(inwardData.length, outwardData.length);
    const rows = [];
    for (let i = 0; i < maxRows; i++) {
      const inRow = inwardData[i] || {};
      const outRow = outwardData[i] || {};
      rows.push([
        i + 1,
        inRow.type || "",
        inRow.gstin || "",
        inRow.docType || "",
        inRow.no || "",
        inRow.date || "",
        inRow.portCode || "",
        inRow.taxable || "",
        inRow.igst || "",
        inRow.cgst || "",
        inRow.sgst || "",
        outRow.type || "",
        outRow.docType || "",
        outRow.no || "",
        outRow.date || "",
        outRow.taxable || "",
        outRow.igst || "",
        outRow.cgst || "",
        outRow.sgst || ""
      ]);
    }
    return rows;
  }, [stmtData]);

  if (!open || !row || !row.client) return null;


  const fullAddress = [
    row.client.address_line_one,
    row.client.address_line_two,
    row.client.city,
    row.client.state,
    row.client.pincode
  ].filter(Boolean).join(", ");

  return (
    <div className={`modal fade ${open ? "show" : ""}`} style={{ display: open ? "block" : "none", backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1" role="dialog">
      <div className="modal-dialog modal-xl modal-dialog-scrollable" role="document">

        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">GST Refund Details - {row.client.firm_name}</h5>
            <button type="button" className="close" onClick={onClose} aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="table-responsive">
              <table className="table custom-table table-bordered mb-0">
                <thead style={{ backgroundColor: "#511989", color: "white" }}>
                  <tr>
                    <th>Applicant Name</th>
                    <th>GSTIN</th>
                    <th>Address</th>
                    <th>Place</th>
                    <th>Designation</th>
                    <th>From (mmyyyy)</th>
                    <th>To (mmyyyy)</th>
                    <th>Refund Formula</th>
                    <th>Refund After Upload</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{row.client.firm_name}</td>
                    <td>{row.client.gstin_no || "N/A"}</td>
                    <td><div style={{ minWidth: '150px', fontSize: '11px' }}>{fullAddress}</div></td>
                    <td>{row.client.city}</td>
                    <td>{extraData.designation}</td>
                    <td>
                      <DatePicker
                        selected={extraData.from}
                        onChange={(date) => {
                          setExtraData({ ...extraData, from: date });
                          updateDatesToApi(date, extraData.to);
                        }}
                        placeholderText="MM/YYYY"
                        dateFormat="MM/yyyy"
                        showMonthYearPicker
                        className="form-control form-control-sm"
                      />
                    </td>
                    <td>
                      <DatePicker
                        selected={extraData.to}
                        onChange={(date) => {
                          setExtraData({ ...extraData, to: date });
                          updateDatesToApi(extraData.from, date);
                        }}
                        placeholderText="MM/YYYY"
                        dateFormat="MM/yyyy"
                        showMonthYearPicker
                        className="form-control form-control-sm"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        value={extraData.refundFormula}
                        onChange={(e) => setExtraData({ ...extraData, refundFormula: e.target.value })}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        value={extraData.refundAfterUpload}
                        onChange={(e) => setExtraData({ ...extraData, refundAfterUpload: e.target.value })}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <hr />

            <div className="d-flex mb-3" style={{ borderBottom: '2px solid #511989' }}>
              <button
                onClick={() => setMainTab('stmt')}
                className={`btn btn-sm ${mainTab === 'stmt' ? 'btn-primary' : 'btn-light'}`}
                style={{ borderRadius: '4px 4px 0 0', marginRight: '4px' }}
              >
                Statement 01A
              </button>
              <button
                onClick={() => setMainTab('annb')}
                className={`btn btn-sm ${mainTab === 'annb' ? 'btn-primary' : 'btn-light'}`}
                style={{ borderRadius: '4px 4px 0 0', marginRight: '4px' }}
              >
                Annexure B
              </button>
              <button
                onClick={() => setMainTab('decl')}
                className={`btn btn-sm ${mainTab === 'decl' ? 'btn-primary' : 'btn-light'}`}
                style={{ borderRadius: '4px 4px 0 0', marginRight: '4px' }}
              >
                Declaration
              </button>
              <button
                onClick={() => setMainTab('monthly')}
                className={`btn btn-sm ${mainTab === 'monthly' ? 'btn-primary' : 'btn-light'}`}
                style={{ borderRadius: '4px 4px 0 0', marginRight: '4px' }}
              >
                Monthly Totals
              </button>
              <button
                onClick={() => setMainTab('maxref')}
                className={`btn btn-sm ${mainTab === 'maxref' ? 'btn-primary' : 'btn-light'}`}
                style={{ borderRadius: '4px 4px 0 0' }}
              >
                Max Refund ●
              </button>
              <button
                onClick={() => setMainTab('gstr2bhsn')}
                className={`btn btn-sm ${mainTab === 'gstr2bhsn' ? 'btn-primary' : 'btn-light'}`}
                style={{ borderRadius: '4px 4px 0 0', marginLeft: '4px' }}
              >
                HSN Lookup (API) ●
              </button>
            </div>

            {mainTab === 'stmt' ? (
              <Statement01AModule rowData={row} extraData={extraData} onDataChange={setStmtData} onTabChange={setMainTab} />
            ) : mainTab === 'annb' ? (
              <AnnexureBModule rowData={row} extraData={extraData} onDataChange={setAnnexRows} />
            ) : mainTab === 'monthly' ? (
              <MonthlyTotalsModule statementRows={statementRows} rowData={row} />
            ) : mainTab === 'maxref' ? (
              <MaxRefundModule annexureRows={annexRows} rowData={row} />
            ) : mainTab === 'gstr2bhsn' ? (
              <Gstr2bHsnModule rowData={row} />
            ) : (
              <DeclarationModule rowData={row} extraData={extraData} />
            )}
          </div>

          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>Close</button>
          </div>
        </div>
      </div>
    </div>
  );
};

const GSTRefundTableModal = ({ open, row, onClose }) => {
  const [tableData, setTableData] = useState({
    arn: "",
    dateOfFiling: moment().format("YYYY-MM-DD"),
    days: "",
    jurisdiction: "",
    refundApplied: "",
    refundDeposit: ""
  });
  const [tasks, setTasks] = useState([]);

  useEffect(() => {
    if (open && row) {
      const clientId = row.client_id || row?.client?.id;
      const lookupId = row.lookup_id || row?.lookup?.id;
      if (clientId && lookupId) {
        axios.post(API_URL.TASK_CLIENT, {
          client_id: clientId,
          lookup_id: lookupId
        }).then((res) => {
          if (res.data.status === 1 && res.data.data.length > 0) {
            // Flatten the step data from the API format to a unified array of tasks
            // or just take the exact raw return directly
            setTasks(res.data.data);
          } else {
            setTasks([]);
          }
        });
      }
    }
  }, [open, row]);

  const toggleTaskStatus = (task) => {
    const nextStatus = task.status === "Completed" ? "Pending" : "Completed";
    axios
      .post(API_URL.TASK_UPDATE_STATUS, {
        client_id: task.client_id,
        lookup_id: task.lookup_id,
        id: task.id,
        status: nextStatus,
      })
      .then((res) => {
        if (res.data.status === 1) {
          setTasks((prev) =>
            prev.map((t) => (t.id === task.id ? { ...t, status: nextStatus } : t))
          );
          toast.success("Status updated successfully");
        } else {
          toast.error("Something went wrong");
        }
      });
  };

  useEffect(() => {
    if (open && row) {
      setTableData({
        arn: row.arn || "",
        dateOfFiling: row.date_of_filing || moment().format("YYYY-MM-DD"),
        days: row.days || "",
        jurisdiction: row.jurisdiction || "",
        refundApplied: row.refund_applied || "",
        refundDeposit: row.refund_deposit || ""
      });
    }
  }, [row, open]);

  if (!open || !row || !row.client) return null;

  const allTasksCompleted = tasks.length > 0 && tasks.every(t => t.status === "Completed");

  const submitData = () => {
    const isCompleted = row.status == 1;
    Swal.fire({
      title: "Are you sure?",
      text: isCompleted ? "You want to update the details?" : "You want to submit and complete this task?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085D6",
      cancelButtonColor: "#d33",
      confirmButtonText: isCompleted ? "Yes, update it!" : "Yes, complete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const calculatedDays = tableData.dateOfFiling ? Math.max(0, moment().startOf('day').diff(moment(tableData.dateOfFiling).startOf('day'), 'days')) : "";

        let payload = {
          id: row.id,
          client_id: row?.client?.id || row.client_id,
          lookup_id: row?.lookup?.id || row.lookup_id,
          status: 1,
          arn: tableData.arn,
          date_of_filing: tableData.dateOfFiling,
          days: calculatedDays,
          jurisdiction: tableData.jurisdiction,
          refund_applied: tableData.refundApplied,
          refund_deposit: tableData.refundDeposit
        };

        axios.post(API_URL.NOT_ROUTING_UPDATE, payload).then((res) => {
          if (res.data.status !== 1) {
            toast.error(res.data.data);
          } else {
            toast.success(isCompleted ? "Details updated successfully" : "Task completed successfully");
            onClose(true); // Passing true triggers a refresh of the main table
          }
        });
      }
    });
  };

  return (
    <div className={`modal fade ${open ? "show" : ""}`} style={{ display: open ? "block" : "none", backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1" role="dialog">
      <div className="modal-dialog modal-lg modal-dialog-scrollable" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Refund Details - {row.client.firm_name}</h5>
            <button type="button" className="close" onClick={() => onClose(false)} aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="table-responsive">
              <table className="table custom-table table-bordered mb-0">
                <thead style={{ backgroundColor: "#511989", color: "white" }}>
                  <tr>
                    <th>ARN</th>
                    <th>Date of Filing</th>
                    <th>Days Gone</th>
                    <th>Jurisdiction</th>
                    <th>Refund Applied</th>
                    <th>Refund Deposit</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        style={{ minWidth: "220px", fontSize: "15px", padding: "8px 10px", fontWeight: "bold" }}
                        placeholder={allTasksCompleted ? "Enter ARN" : "Complete tasks first"}
                        value={tableData.arn}
                        disabled={!allTasksCompleted}
                        onChange={e => setTableData({ ...tableData, arn: e.target.value })}
                      />
                    </td>
                    <td>
                      <input
                        type="date"
                        className="form-control form-control-sm"
                        value={tableData.dateOfFiling}
                        disabled={!tableData.arn}
                        onChange={e => setTableData({ ...tableData, dateOfFiling: e.target.value })}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="form-control form-control-sm text-center"
                        value={tableData.dateOfFiling ? Math.max(0, moment().startOf('day').diff(moment(tableData.dateOfFiling).startOf('day'), 'days')) : ""}
                        readOnly
                        style={{ backgroundColor: "#e9ecef", fontWeight: "bold" }}
                      />
                    </td>
                    <td>
                      <input type="text" className="form-control form-control-sm" value={tableData.jurisdiction} disabled={!tableData.arn} onChange={e => setTableData({ ...tableData, jurisdiction: e.target.value })} />
                    </td>
                    <td>
                      <input type="text" className="form-control form-control-sm" value={tableData.refundApplied} disabled={!tableData.arn} onChange={e => setTableData({ ...tableData, refundApplied: e.target.value })} />
                    </td>
                    <td>
                      <input type="text" className="form-control form-control-sm" value={tableData.refundDeposit} disabled={!tableData.arn} onChange={e => setTableData({ ...tableData, refundDeposit: e.target.value })} />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            {tasks && tasks.length > 0 && (
              <div className="mt-4">
                <h6 style={{ fontWeight: "bold" }}>Tasks</h6>
                <div style={{ maxHeight: "200px", overflowY: "auto", border: "1px solid #dee2e6", borderRadius: "5px", padding: "10px" }}>
                  {tasks.map((task, index) => (
                    <div key={index} className="form-check mb-2 d-flex align-items-center">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id={`taskCheck${task.id}`}
                        checked={task.status === "Completed"}
                        disabled={index > 0 && tasks[index - 1].status !== "Completed"}
                        onChange={() => toggleTaskStatus(task)}
                        style={{
                          cursor: index > 0 && tasks[index - 1].status !== "Completed" ? "not-allowed" : "pointer",
                          transform: "scale(1.2)",
                          marginTop: 0
                        }}
                      />
                      <label
                        className="form-check-label ml-2 mb-0"
                        htmlFor={`taskCheck${task.id}`}
                        style={{
                          cursor: index > 0 && tasks[index - 1].status !== "Completed" ? "not-allowed" : "pointer",
                          fontSize: "14px",
                          textDecoration: task.status === "Completed" ? "line-through" : "none",
                          color: task.status === "Completed" ? "#6c757d" :
                            (index > 0 && tasks[index - 1].status !== "Completed" ? "#adb5bd" : "inherit"),
                          transition: "all 0.2s ease"
                        }}
                      >
                        {task.steps?.for_what || "Task"}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-theme text-white"
              onClick={submitData}
              disabled={!tableData.arn || !tableData.jurisdiction || !tableData.refundApplied}
            >
              {row.status == 1 ? "Update Details" : "Submit"}
            </button>
            <button type="button" className="btn btn-secondary" onClick={() => onClose(false)}>Close</button>
          </div>
        </div>
      </div>
    </div>
  );
};
